import type { IconProps } from '../types/IconProps.ts';
export const ShieldQuestion: IconProps = {
    name: 'ShieldQuestion',
    children: [
        `<path d="M4 5.18q.02-.2.23-.23a11.4 11.4 0 0 0 6.79-2.29l.8-.6c.1-.08.25-.08.35 0l.81.6a11.5 11.5 0 0 0 6.8 2.3q.2.02.22.22v6.72a10.3 10.3 0 0 1-8.02 10.02A10.3 10.3 0 0 1 4 11.9z" />`,
        `<path d="M9.17 9A3 3 0 0 1 15 10c0 1.66-1.34 3.5-3 3.5" />`,
        `<circle cx="12" cy="17" r=".5" />`,
    ]
};